import { useState } from "react";
import { PaziaModal } from "components/molecules";
import { PaziaButton } from "components/atoms";
import { ModalHeader } from "../../components/templates/Modals/ModalHeader";
import { ModalPadding } from "../../components/templates/Modals/ModalPadding";
import { useBulkSendTrainerInvite } from "api/hooks";
import { useToaster } from "utils/toaster";
import { BulkTrainerActionResultApi } from "api/trainers/trainerAccountApi";
import { BulkTrainerActionResultSummary } from "./BulkTrainerActionResultSummary";

interface BulkSendTrainerInviteModalProps {
  isOpen: boolean;
  onCloseRequest: () => void;
  selectedTrainerIds: number[];
  onSuccess: () => void;
}

export const BulkSendTrainerInviteModal = ({
  isOpen,
  onCloseRequest,
  selectedTrainerIds,
  onSuccess,
}: BulkSendTrainerInviteModalProps) => {
  const { showError } = useToaster();
  const bulkSendInviteMutation = useBulkSendTrainerInvite();
  const [result, setResult] = useState<BulkTrainerActionResultApi | null>(null);

  const handleSubmit = async () => {
    try {
      const { data } = await bulkSendInviteMutation.mutateAsync(selectedTrainerIds);
      setResult(data);
      onSuccess();
    } catch {
      showError("Nie udało się wysłać zaproszeń");
    }
  };

  const handleClose = () => {
    setResult(null);
    onCloseRequest();
  };

  return (
    <PaziaModal id="bulk-send-trainer-invite-modal" isOpen={isOpen} onCloseRequest={handleClose} size="full">
      <ModalPadding>
        {result ? (
          <BulkTrainerActionResultSummary
            result={result}
            successVerb="Wysłano zaproszenie"
            totalLabel="trenerów"
            onClose={handleClose}
          />
        ) : (
          <>
            <ModalHeader>Wyślij zaproszenie do panelu ({selectedTrainerIds.length} trenerów)</ModalHeader>
            <div className="mt-4 text-sm text-slate-600 dark:text-slate-300">
              Zaproszenie z linkiem do ustawienia hasła zostanie wysłane do zaznaczonych trenerów, którzy mają już
              utworzone konto. Pozostali zostaną pominięci, a po zakończeniu zobaczysz podsumowanie.
            </div>
            <div className="mt-6 flex justify-end gap-3">
              <PaziaButton type="secondary" onClick={handleClose} disabled={bulkSendInviteMutation.isPending}>
                Anuluj
              </PaziaButton>
              <PaziaButton
                type="primary"
                onClick={handleSubmit}
                disabled={selectedTrainerIds.length < 1 || bulkSendInviteMutation.isPending}
                processing={bulkSendInviteMutation.isPending}
              >
                Wyślij zaproszenia
              </PaziaButton>
            </div>
          </>
        )}
      </ModalPadding>
    </PaziaModal>
  );
};
